module.exports = __webpack_public_path__ + "components/rewards/sport-pursuit/static/logo-edadf99205bb431adc2258eee5b8b5e6.jpg";